import { render, staticRenderFns } from "./JudoDashboard.vue?vue&type=template&id=a54943cc&scoped=true"
import script from "./JudoDashboard.vue?vue&type=script&lang=js"
export * from "./JudoDashboard.vue?vue&type=script&lang=js"
import style0 from "./JudoDashboard.vue?vue&type=style&index=0&id=a54943cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54943cc",
  null
  
)

export default component.exports